<template>
  <card class="no-border-card card-comments" id="comments">
    <template slot="header">
      <b-row align-v="center">
        <b-col sm="6">
          <div class="icon-actions">
            <h3>Comments</h3>
            <!--a href="#" class="like active js-recipe-likes" @click="handleLike($event, recipeData)">
              <i class="ni ni-like-2"></i>
              <span class="text-muted">{{ recipeData.likes }}</span>
            </a-->
            <a href="#comments" class="like active js-recipe-likes">
              <i class="ni ni-chat-round"></i>
              <span class="text-muted">{{ commentCount }}</span>
            </a>
            <!--a href="#">
              <i class="ni ni-curved-next"></i>
              <span class="text-muted">{{ recipeData.shares }}</span>
            </a-->
          </div>
        </b-col>
        <!--b-col sm="6" class="d-none d-sm-block">
          <div class="d-flex align-items-center justify-content-sm-end">
            <div class="avatar-group">
              <a href="#" class="rounded-circle avatar avatar-xs" data-toggle="tooltip" data-original-title="Jessica Rowland">
                <b-img rouned="circle" alt="Image placeholder" src="/img/theme/team-1.jpg" class="" />
              </a>
              <a href="#" class="avatar avatar-xs rounded-circle" data-toggle="tooltip" data-original-title="Audrey Love">
                <b-img rouned="circle" alt="Image placeholder" src="/img/theme/team-2.jpg" />
              </a>
              <a href="#" class="avatar avatar-xs rounded-circle" data-toggle="tooltip" data-original-title="Michael Lewis">
                <b-img rouned="circle" alt="Image placeholder" src="/img/theme/team-3.jpg" />
              </a>
            </div>
            <small class="pl-2 font-weight-bold" v-if="recipeData.comments">{{ recipeData.comments.more }}</small>
          </div>
        </b-col-->
      </b-row>
    </template>

    <!-- Comments -->
    <div class="mb-1 comments scrollbar-inner">

      <b-media no-body class="align-items-center">
        <b-img rounded="circle" alt="Image placeholder" class="avatar avatar-lg mr-2" 
        v-bind:src="this.userData.image ? userData.image.absoluteUri : '/img/DefaultUser.gif'" />
        <b-media-body >
          <b-form role="form" @submit.prevent="handleComment()">
            <base-input 
                        name="commentText"
                        type="textarea"
                        placeholder="Write your comment"
                        v-model="model.commentText">
            </base-input>
          </b-form>
        </b-media-body>
      </b-media>

      <hr>

      <comment v-for="comment in commentData.slice().reverse()" :key="comment.index"
        :comment="comment" 
        />
      
    </div>
  </card>
</template>
<script>
  import Comment from '@/components/Feed/Comment';
  import PerfectScrollbar from 'perfect-scrollbar';

  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
        
        const container = document.querySelector( container.prop( "scrollHeight" ) );
      }, 100);
    }
  }
  
  export default {
    name: 'recipe-comments',
    props: ['recipeId'],
    components: {
      Comment
    },
    data() {
      return {
        model: {
          commentText: ''
        }
      }
    },
    computed: {
      apiKey() {
        return this.data && this.data.api_key;
      },
      recipeData() {
        return this.$store.state.recipes.current
      },
      commentData() {
        return this.$store.state.comments.current
      },
      userData() {
          return this.$store.state.authentication.user.user;
      },
      commentsLoading() {
          return this.$store.state.comments.loading
      },
      commentCount() {
          return Object.keys(this.$store.state.comments.current).length
      }
    },
    methods: {
      handleLike(event, recipe) {
        event.preventDefault();

        const likeButton = event.target.closest('.like');

        if (likeButton) {
          likeButton.classList.contains('active') ? recipe.likes-- : recipe.likes++;

          document.querySelectorAll('.js-recipe-likes').forEach(function(button){
            button.classList.toggle('active');
          });
        }
      },
      storeComments() {
          const commentData = {
              recipeId: this.recipeId
          };
          try {
              this.$store.dispatch("comments/getComments", commentData)
                  .then(response => {
                  }).catch(error => {
                      console.log('Something went wrong: ', error);
                  });
          } catch (error) {
              console.log("Error: Favorite", error);
          }
      },
      initScrollbar() {
        //let isWindows = navigator.platform.startsWith('Win');
        //if (isWindows) {
          initScrollbar('comments');
        //}
      },
      handleComment() {
        if ( this.model.commentText ) {
          const commentData = {
              userId: this.userData.id,
              recipeId: this.recipeData.id,
              comment: this.model.commentText
          };
          try {
              this.$store.dispatch("comments/addComment", commentData)
                  .then(response => {
                    this.storeComments();
                    this.model.commentText = '';
                  }).catch(error => {
                      console.log('Something went wrong: ', error);
                  });
          } catch (error) {
              console.log("Error: Comment", error);
          }
        }
      },
      onCreated() {
        this.storeComments();
      }
    },
    created() {
      this.onCreated();
    },
    mounted() {
      this.initScrollbar();
    },
    watch: {
        $route(to, from) {
            this.onCreated();
        },
        commentData(to, from) {
        }
    }
  }
</script>
<style>
.comments {
  height:400px;
  overflow:hidden;
  position:relative
}
</style>
